// extracted by mini-css-extract-plugin
export var buttonFadeInAnimation = "ShortsCard-module--buttonFadeInAnimation--5a176";
export var card = "ShortsCard-module--card--4676e";
export var contentWrapper = "ShortsCard-module--contentWrapper--43413";
export var current = "ShortsCard-module--current--63f61";
export var dark = "ShortsCard-module--dark--d14ee";
export var fadeInAnimation = "ShortsCard-module--fadeInAnimation--e670e";
export var fullScreenButton = "ShortsCard-module--fullScreenButton--1abe1";
export var fullScreenIcon = "ShortsCard-module--fullScreenIcon--595b9";
export var hidePreview = "ShortsCard-module--hidePreview--39dd9";
export var innerLayout = "ShortsCard-module--innerLayout--7bca8";
export var name = "ShortsCard-module--name--273d4";
export var picture = "ShortsCard-module--picture--1f531";
export var pictureWrapper = "ShortsCard-module--pictureWrapper--8f5f7";
export var playIcon = "ShortsCard-module--playIcon--ecac9";
export var playerButton = "ShortsCard-module--playerButton--9e66c";
export var playerButtonIcon = "ShortsCard-module--playerButtonIcon--e57f1";
export var playerFloatingButton = "ShortsCard-module--playerFloatingButton--d4e74";
export var playerHead = "ShortsCard-module--playerHead--43ba3";
export var playerTopRow = "ShortsCard-module--playerTopRow--b29e4";
export var position = "ShortsCard-module--position--c6f57";
export var progressBar = "ShortsCard-module--progressBar--31d9e";
export var progressBarBackground = "ShortsCard-module--progressBarBackground--25908";
export var progressBarContainer = "ShortsCard-module--progressBarContainer--3bd89";
export var showControls = "ShortsCard-module--showControls--e19d8";
export var showOnDesktop = "ShortsCard-module--showOnDesktop--275e5";
export var text = "ShortsCard-module--text--d576a";
export var time = "ShortsCard-module--time--c32db";
export var title = "ShortsCard-module--title--c382f";
export var video = "ShortsCard-module--video--fd31c";
export var videoControls = "ShortsCard-module--videoControls--3160b";
export var videoWrapper = "ShortsCard-module--videoWrapper--4b87a";
export var volume = "ShortsCard-module--volume--b6459";
export var volumeIcon = "ShortsCard-module--volumeIcon--af9b6";
export var volumeInput = "ShortsCard-module--volumeInput--c0f78";
export var volumeInputContainer = "ShortsCard-module--volumeInputContainer--7f61b";
export var withHover = "ShortsCard-module--withHover--4a763";
export var withTransition = "ShortsCard-module--withTransition--bd6cf";